<template>
  <div class="useStatisticsNew">
    <!-- <div class="full-title">使用量统计</div> -->
    <div class="control-bar">
      <div class="level">机构名称</div>
      <div class="statusBox">
        <div class="statusBoxFlex">
          <div class="status"><span class="status-color" :style="{ 'background-color': useColor }"></span> 已使用</div>
          <div class="status"><span class="status-color status-opacity" :style="{ 'background-color': useColor }"></span> 已下发</div>
        </div>
      </div>
      <div class="useText" v-for="(item, index) in sortList" @click="sortUse(item)" :key="index">
        <p>
          <span
            class="useText-arrow"
            :style="{ 'border-top-color': useColor }"
            :class="[item.click ? 'opacity' : '', item.arrow ? 'click-arrow' : '']"
          ></span>
          {{ item.name }}
        </p>
      </div>
    </div>
    <ul class="chartsList">
      <li class="chartItem" v-for="(item, i) in useList" :key="i">
        <div class="level">
          <!-- <el-popover placement="top-start" title="" width="200" trigger="hover" :content="item.deptName">
            <el-button slot="reference">
              <span v-if="item.deptName.length>4">{{ item.deptName.slice(0, 5) }}</span>
              <span v-else>{{ item.deptName }}</span>
            </el-button>
          </el-popover> -->
          <el-tooltip class="item" effect="dark" :content="item.deptName" placement="right">
            <el-button style="font-size: 12px">
              <span>{{ item.deptName.slice(0, 4) }}<span v-if="item.deptName.length > 4">...</span></span>
            </el-button>
          </el-tooltip>
          <!-- <span v-else style="font-size: 12px">{{ item.deptName }}</span> -->
        </div>
        <div class="progressWrapper">
          <div
            class="totalProgress"
            :style="{ width: `${totalProgress(item.hasBeenIssued)}%`, 'background-color': useColor, opacity: 0.5 }"
          >
            <!--inner-->
          </div>
          <div :style="{ width: `${totalProgress(item.hasBeenUsed)}%` || 0 }" class="progressWrapper-progress">
            <transition
              name="useProgress"
              appear
              appear-class="useProgress-appear-class"
              appear-active-class="useProgress-appear-active-class"
              appear-to-class="useProgress-appear-to-class"
            >
              <div class="useProgress" :style="{ 'background-color': useColor, height: '15px' }"></div>
            </transition>
          </div>
        </div>
        <div class="usePCT">{{ item.usageRate }}</div>
        <div class="remainder">{{ item.theRemaining }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    useList: {
      type: Array,
      default: []
    },
    useColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      useFlag: true,
      remainderFlag: false,
      sortList: [
        {
          name: '使用率',
          click: false,
          arrow: false
        },
        {
          name: '剩余量',
          click: false,
          arrow: false
        }
      ]
    };
  },
  // mounted () {
  //   this.$emit('getList', true ? 'desc' : 'asc', null)
  // },
  methods: {
    totalProgress(hasBeenIssued) {
      // let max = Math.max.apply(Math, this.useList.map(item => { return item.hasBeenIssued }))
      // // console.log((hasBeenIssued/max) * 100, 'max')
      // return (hasBeenIssued / max) * 100
      if (hasBeenIssued > 0) {
        let max = Math.max.apply(
          Math,
          this.useList.map(item => {
            return item.hasBeenIssued;
          })
        );
        return (hasBeenIssued / max) * 100;
      } else {
        return 0;
      }
    },
    sortUse(item) {
      item.arrow = !item.arrow;
      if (item.name === '使用率') {
        this.$emit('getList', item.arrow ? 'asc' : 'desc', null);
      } else {
        this.$emit('getList', null, item.arrow ? 'asc' : 'desc');
      }
      this.sortList.forEach(val => {
        val.click = false;
      });
      item.click = true;
    }
    // sortRemainder() {
    //   this.remainderFlag = !this.remainderFlag
    //   this.$emit('getList', null, this.remainderFlag ? 'desc' : 'asc')
    // },
  },
  watch: {
    useColor(val) {
      this.useColor = val;
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
.useStatisticsNew {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;

  .headTitle {
    height: 20px;
    line-height: 20px;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
  }

  .control-bar {
    display: flex;
    // justify-content: space-between;
    font-size: 12px;
    color: white;
    height: 20px;

    //text-align: center;
    .level {
      width: 65px;
      text-align: right;
      font-size: 12px;
      box-sizing: border-box;
      padding-right: 10px;
    }

    .statusBox {
      flex: 1;
      .statusBoxFlex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 2px;
      }

      .status {
        // width: 100px;
        line-height: 14px;
        vertical-align: middle;
        position: relative;
        padding-left: 22px;
      }

      .status-color {
        display: inline-block;
        content: ' ';
        width: 14px;
        height: 14px;
        background-color: #00f9ee;
        border-radius: 2px;
        vertical-align: middle;
        position: absolute;
        left: 0;
        top: 0;
      }

      .status-opacity {
        opacity: 0.5;
      }
    }

    .useText {
      width: 65px;
      pointer-events: none;
      text-align: right;
      p {
        position: relative;
        padding-left: 20px;
        display: inline-block;
      }
    }

    .remainderText {
      // width: 80px;
      pointer-events: none;
    }

    .useText-arrow {
      vertical-align: middle;
      width: 0;
      height: 0;
      border-top: 6px solid #00f9ee;
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
      cursor: pointer;
      pointer-events: auto;
      position: absolute;
      left: 0;
      top: 7px;
      opacity: 0.5;
    }

    .opacity {
      opacity: 1;
    }
    .click-arrow {
      transform: rotate(180deg);
      animation-duration: 2s;
    }
    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(180deg);
      }
    }
  }

  .chartsList {
    // border-bottom: 2px solid rgba(216, 216, 216, 0.3);
    height: calc(100% - 18px);
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    .el-button {
      background: none;
      border: none;
      color: #d9d9d9;
      padding: 2px 0 0 0;
    }
    .el-popover--plain {
      padding: 0 !important;
    }

    //padding-bottom: 30px;
    .chartItem {
      display: flex;
      justify-content: space-between;
      text-align: center;
      // margin-top: 20px;
      margin: 10px 0;

      .level {
        font-size: 12px;
        width: 65px;
        color: #d9d9d9;
        // margin-right: 20px;
        text-align: right;
        box-sizing: border-box;
        padding-right: 10px;
      }

      .progressWrapper {
        flex: 1;
        position: relative;
        margin-top: 2px;
        &-progress {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          background-color: #00f9ee;
        }

        .totalProgress {
          height: 15px;
          background-color: #00f9ee;
          border-radius: 2px;

          .useProgress {
            width: 100%;
            height: 15px;
            background-color: #00f9ee;
            border-radius: 2px;
          }

          .useProgress-appear-class {
            width: 0;
            height: 20px;
            background-color: #00f9ee;
            border-radius: 2px;
          }

          .useProgress-appear-active-class {
            transition: width 3s;
          }

          .useProgress-appear-to-class {
            width: 100%;
            height: 15px;
            background-color: #00f9ee;
            border-radius: 2px;
          }
        }
      }

      //.totalProgress .useProgress{
      //  width: 100%;
      //}
      .usePCT {
        width: 65px;
        color: #d9d9d9;
        font-size: 13px;
        text-align: right;
      }

      .remainder {
        width: 65px;
        color: #d9d9d9;
        font-size: 13px;
        text-align: right;
      }
    }
    .chartItem:last-child {
      margin-bottom: 20px;
    }
  }

  .chartsList::-webkit-scrollbar {
    display: none;
  }

  .rate {
    display: flex;
  }
}
</style>
<style lang="scss" scoped>
.useStatisticsNew {
  //width: calc(100% - 40px);
  //height: calc(100vh - 290px);
  //background: rgba(0, 0, 0, .2);
  //box-shadow: 0 0 10px rgba(128, 255, 255, .5);
  // height: 621px;
  // padding: 0;
}
.useStatisticsNew .control-bar {
  // margin-top: 20px;
  // margin-bottom: 15px;
}
.useStatisticsNew .control-bar .statusBox .status-color {
  background-color: #1d5fd1;
}
.useStatisticsNew .control-bar .statusBox .status-opacity {
  background-color: #1f3e73;
  opacity: 1;
}
.useStatisticsNew .control-bar .useText-arrow {
  border-top: 6px solid #1d5fd1;
}
.useStatisticsNew .chartsList .chartItem .progressWrapper-progress {
  background-color: #1d5fd1;
}
.useStatisticsNew .chartsList .chartItem .progressWrapper .totalProgress {
  background-color: #1f3e73;
  opacity: 1;
}
.useStatisticsNew .control-bar .level {
  // width: 100px;
  // margin-right: 30px;
}
.useStatisticsNew .chartsList .chartItem:first-child {
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/component/useStatisticsModule.vue